export enum PanelName {
	CommentsPanel = 'commentsPanel',
	DetailsPanel = 'detailsPanel',
	AgentReceiptPanel = 'agentReceiptPanel',
	WorkflowsPanel = 'workflowsPanel',
}

const MIGRATED_PANEL_IDS: ReadonlySet<string> = new Set([
	PanelName.CommentsPanel,
	PanelName.DetailsPanel,
	PanelName.AgentReceiptPanel,
	'jiraWorkItemsPanel',
]);

export function isMigratedToPanelSystem(panelId: string | undefined): boolean {
	return !!panelId && MIGRATED_PANEL_IDS.has(panelId);
}
